<div class="d-flex flex-column justify-content-center align-items-center cursor-pointer p-8 m-y-4 m-x-6" (click)="emitAction()">
  <img [ngClass]="selected ? 'shadow-2' : 'shadow-1'" class="rounded-circle"
       [ngSrc]="imagePath ? baseImageUrl +  imagePath : './assets/images/item.png'"
       onerror="this.src='./assets/images/item.png'"
       alt="" width="100" height="100">
  <p class="m-t-4 text-center" [ngClass]="selected ? 'f-w-800' : 'f-w-500'">{{title}}</p>
</div>
